import { PromptSettingsLiveStatus } from 'src/components/Prompt/constants';
import { TerritoryLivePromptActiveFilter } from 'src/components/TerritoryFilter/constants';

export const mapFilterToLiveStatus = (filter: TerritoryLivePromptActiveFilter): PromptSettingsLiveStatus => {
  const statusMap: Record<TerritoryLivePromptActiveFilter, PromptSettingsLiveStatus> = {
    [TerritoryLivePromptActiveFilter.active]: PromptSettingsLiveStatus.LIVE,
    [TerritoryLivePromptActiveFilter.upcoming]: PromptSettingsLiveStatus.UPCOMING,
    [TerritoryLivePromptActiveFilter.completed]: PromptSettingsLiveStatus.COMPLETED,
  };

  return statusMap[filter];
};
